import { c as _c } from "react/compiler-runtime";
import { BestSellersSingleBlock } from "./BestSellersSingleBlock";
import type { Offer } from "@local/offer/src/types";
export const BestSellersMappedBlocks = t0 => {
  const $ = _c(11);
  const {
    isVisible,
    products,
    skipFirst,
    vertical,
    market
  } = t0;
  let t1;
  if ($[0] !== isVisible || $[1] !== market || $[2] !== products || $[3] !== skipFirst || $[4] !== vertical) {
    t1 = products?.map((product, i) => {
      if (skipFirst && i === 0) {
        return null;
      }
      return <div key={`best-sellers-${product.id}`}><BestSellersSingleBlock product={product} index={i + 1} isVisible={isVisible} vertical={vertical} market={market} /></div>;
    });
    $[0] = isVisible;
    $[1] = market;
    $[2] = products;
    $[3] = skipFirst;
    $[4] = vertical;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== isVisible) {
    t2 = !isVisible && <div className="pointer-events-none absolute inset-0 z-0! bg-gradient-to-b from-transparent from-30% via-transparent to-white md:hidden" />;
    $[6] = isVisible;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="relative grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-x-9 md:gap-y-3">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};